<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="exportdata"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :title="'Export '+file_name"
    ref="exportdata"
    :hide-footer="data.length>0"
  >
    <b-form class="mx-auto text-center" v-if="data.length>0">
      <b-form-group label="File type" label-class="required" horizontal label-for="filetype">
        <b-form-radio-group v-model="file_type" :options="types"></b-form-radio-group>
      </b-form-group>

      <downloadexcel
        class="btn excel_export btn-outline-primary text-center mt-3"
        :fetch="fetchData"
        :exportDatas="columns"
        :before-generate="startDownload"
        :before-finish="finishDownload"
        :type="file_type"
        :name="file_name+'.'+file_type"
        :class="submitted?'disabled':''"
      >
        <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
        <span v-else class="no_caret_import la la-download mr-3"></span>
        Export
      </downloadexcel>
    </b-form>
    <p v-else>No Records found</p>
  </b-modal>
</template>
  

<script>
import { notificationMixin } from "@/mixins/notification";
import downloadexcel from "@/components/DownloadExcel/DownloadExcel"; // to excel export the output

export default {
  mixins: [notificationMixin],
  components: { downloadexcel },
  data() {
    return {
      types: [
        {
          value: "xls",
          text: "XLS"
        },
        { value: "csv", text: "CSV" }
      ],
      file_type: "xls",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false
    };
  },
  props: ["title", "data", "columns", "file_name"],
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  methods: {
    fetchData() {
      return this.data;
    },
    startDownload() {
      this.submitted = true;
    },
    finishDownload() {
      this.submitted = false;
      this.$emit("downloaded");
    }
  }
};
</script>

<style>
</style>
